<template>
    <!-- 新增表格数据的dialog -->
    <div>
        <el-dialog
            :visible.sync="addDialogVisible"
            :close-on-click-modal="false"
            width="50%"
            :before-close="handleToClose"
            title="新增商家"
        >
            <el-form :model="addForm" ref="addForm" :rules="rules" label-width="80px" label-position="center">
                <el-row type="flex" class="row-bg" justify="space-around">
                    <el-col :span="12"
                        ><div class="grid-content bg-purple-light">
                            <el-form-item label="商家类型" prop="merchantType">
                                <el-select v-model="addForm.merchantType" placeholder="请选择商家类型">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item></div
                    ></el-col>
                    <el-col :span="12"
                        ><div class="grid-content bg-purple-light">
                            <el-form-item label="门店名称" prop="merchantName">
                                <el-input v-model.trim="addForm.merchantName" placeholder="请输入门店名称"></el-input>
                            </el-form-item></div
                    ></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="工作时间" style="margin-bottom:0;">
                            <el-col :span="12">
                                <el-form-item prop="startWorkTime">
                                    <el-time-picker
                                        v-model="addForm.startWorkTime"
                                        class="date-box"
                                        format="HH:mm"
                                        value-format="HH:mm"
                                        placeholder="请选择开始时间"
                                        :picker-options="{
                                            selectableRange: `00:00:00 -${addForm.endWorkTime ? addForm.endWorkTime + ':00' : '23:59:00'}`
                                        }"
                                    >
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item prop="endWorkTime">
                                    <el-time-picker
                                        v-model="addForm.endWorkTime"
                                        format="HH:mm"
                                        value-format="HH:mm"
                                        placeholder="请选择结束时间"
                                        :picker-options="{
                                            selectableRange: `${
                                                addForm.startWorkTime ? addForm.startWorkTime + ':00' : '00:00:00'
                                            }-23:59:00`
                                        }"
                                    >
                                    </el-time-picker>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="门店地址">
                            <el-col :span="8">
                                <el-form-item prop="province">
                                    <el-select
                                        v-model="addForm.province"
                                        filterable
                                        size="small"
                                        @change="selectProvinceFun($event)"
                                        placeholder="请选择省份"
                                    >
                                        <el-option value="" label="请选择省份"></el-option>
                                        <el-option
                                            :value="item.name"
                                            :label="item.name"
                                            v-for="(item, index) in city"
                                            :key="index"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item prop="city">
                                    <el-select
                                        v-model="addForm.city"
                                        filterable
                                        size="small"
                                        @change="selectCityFun($event)"
                                        placeholder="请选择城市"
                                    >
                                        <el-option value="" label="请选择城市"></el-option>
                                        <el-option
                                            :value="item.name"
                                            :label="item.name"
                                            v-for="(item, index) in cityList"
                                            :key="index"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item prop="area">
                                    <el-select
                                        v-model="addForm.area"
                                        filterable
                                        size="small"
                                        @change="selectAreaFun($event)"
                                        placeholder="请选择区县"
                                    >
                                        <el-option value="" label="请选择区县"></el-option>
                                        <el-option :value="item" :label="item" v-for="(item, index) in areaList" :key="index"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户名" prop="merchantLoginName">
                            <el-input v-model.trim="addForm.merchantLoginName" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" prop="merchantAddress">
                            <el-input v-model.trim="addForm.merchantAddress" placeholder="请输入门店详细地址"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="登录密码" prop="merchantPassword">
                            <el-input
                                v-model.trim="addForm.merchantPassword"
                                placeholder="请输入登录密码"
                                :type="pwdType1"
                                oninput="value=value.replace(/[\W]/g,'')"
                            >
                                <i slot="suffix" class="el-input__icon el-icon-view" :class="{ pwd: isPwd1 }" @click="handleToPwd1"></i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商家卖点" prop="merchantFeatures">
                            <el-input v-model.trim="addForm.merchantFeatures" placeholder="请输入商家卖点"> </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系电话" prop="merchantTelephone">
                            <el-input v-model.trim="addForm.merchantTelephone" placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12"> </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="资质照片" prop="merchantQuantityImg">
                            <el-upload
                                class="avatar-uploaders"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-success="quaHandleAvatarSuccess"
                                :before-upload="BeforeAvatarUpload"
                            >
                                <img v-if="quaImageUrl" :src="quaImageUrl" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                <div class="el-upload__tip">温馨提示：建议上传一张宽高比为 7:5 的图片,建议：350px*250px</div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="logo图片" prop="merchantImg">
                            <el-upload
                                class="avatar-uploader"
                                :action="uploadUrl"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                                :on-change="uploadHandleChange"
                                :http-request="handleHttpRequest"
                                :auto-upload="false"
                            >
                                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                              
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="门店服务" prop="merchantServer">
                    <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
                        {{ tag }}
                    </el-tag>
                    <el-input
                        class="input-new-tag"
                        v-if="inputVisible"
                        v-model="addForm.merchantServer"
                        ref="saveTagInput"
                        size="small"
                        @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm"
                    >
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+标签</el-button>
                </el-form-item>
                <el-form-item label="门店简介" prop="merchantIntroduction">
                    <quill-editor
                        v-model="addForm.merchantIntroduction"
                        ref="myQuillEditor"
                        class="editor ql-editor editReset"
                        id="editor"
                        @change="onEditorChange($event)"
                        @keydown.native="onEditorKeyDown($event)"
                        @blur="onEditorblur()"
                    ></quill-editor>
                </el-form-item>

                <div class="dialog-footer">
                    <el-button type="info" @click="handleToClose">取 消</el-button>
                    <el-button type="primary" @click="submitForm('addForm')">确 定</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="图片剪裁" :visible.sync="logoDialogVisible" append-to-body :close-on-click-modal="false">
            <div class="cropper-content">
                <div class="cropper" style="text-align: center;">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber"
                        :centerBox="option.centerBox"
                        :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox"
                    ></vueCropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeScale(1)">+</el-button>
                <el-button @click="changeScale(-1)">-</el-button>
                <el-button @click="rotateLeft">↺</el-button>
                <el-button @click="rotateRight">↻</el-button>
                <el-button @click="logoDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="finish">上传</el-button>
            </div>
        </el-dialog>
        <!-- <el-dialog title="图片剪裁" :visible.sync="quaDialogVisible" append-to-body :close-on-click-modal="false">
            <div class="cropper-content">
                <div class="cropper" style="text-align: center;">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.size"
                        :outputType="option.outputType"
                        :info="true"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :fixed="option.fixed"
                        :fixedNumber="option.fixedNumber"
                        :centerBox="option.centerBox"
                        :infoTrue="option.infoTrue"
                        :fixedBox="option.fixedBox"
                    ></vueCropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeScale(1)">+</el-button>
                <el-button @click="changeScale(-1)">-</el-button>
                <el-button @click="rotateLeft">↺</el-button>
                <el-button @click="rotateRight">↻</el-button>
                <el-button type="info" @click="quaDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="finishs">上传</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>
import city from '@/assets/json/map.json';
import { quillEditor } from 'vue-quill-editor';
const titleConfig = [
    { Choice: '.ql-bold', title: '加粗' },
    { Choice: '.ql-italic', title: '斜体' },
    { Choice: '.ql-underline', title: '下划线' },
    { Choice: '.ql-header', title: '段落格式' },
    { Choice: '.ql-strike', title: '删除线' },
    { Choice: '.ql-blockquote', title: '块引用' },
    { Choice: '.ql-code', title: '插入代码' },
    { Choice: '.ql-code-block', title: '插入代码段' },
    { Choice: '.ql-font', title: '字体' },
    { Choice: '.ql-size', title: '字体大小' },
    { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
    { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
    { Choice: '.ql-direction', title: '文本方向' },
    { Choice: '.ql-header[value="1"]', title: 'h1标题' },
    { Choice: '.ql-header[value="2"]', title: 'h2标题' },
    { Choice: '.ql-align', title: '对齐方式' },
    { Choice: '.ql-color', title: '字体颜色' },
    { Choice: '.ql-background', title: '背景颜色' },
    { Choice: '.ql-image', title: '图像' },
    { Choice: '.ql-video', title: '视频' },
    { Choice: '.ql-link', title: '添加链接' },
    { Choice: '.ql-formula', title: '插入公式' },
    { Choice: '.ql-clean', title: '清除字体格式' },
    { Choice: '.ql-script[value="sub"]', title: '下标' },
    { Choice: '.ql-script[value="super"]', title: '上标' },
    { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
    { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
    { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
    { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
    { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
    { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
    { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
    { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
    { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
    { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
    { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
    { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
    { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
    { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
    { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
    {
        Choice: '.ql-align .ql-picker-item[data-value="center"]',
        title: '居中对齐'
    },
    {
        Choice: '.ql-align .ql-picker-item[data-value="right"]',
        title: '居右对齐'
    },
    {
        Choice: '.ql-align .ql-picker-item[data-value="justify"]',
        title: '两端对齐'
    }
];
export default {
    components: {
        quillEditor
    },
    data() {
        var checkMerchantName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入门店名称'));
            }
            let data = {};
            data.merchantName = this.addForm.merchantName;
            data.id = '';
            this.$axios.post('merchant/judgeMerchantName', data).then(res => {
                if (res.data.code != 0) {
                    callback(new Error(res.data.data));
                } else {
                    callback();
                }
            });
        };
        var checkMerchantAddress = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入门店详细地址'));
            }else{
                callback()
            }
        };
        var checkLoginName = (rule, value, callback) => {
            if (value) {
                var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
                if (!reg.test(value)) {
                    callback(new Error('用户名6-16位仅支持字母、数字的组合'));
                } else {
                    let data = {};
                    data.merchantLoginName = this.addForm.merchantLoginName;
                    this.$axios.post('merchant/judgeMerchantLoginName', data).then(res => {
                        if (res.data.code != 0) {
                            callback(new Error(res.data.data));
                        } else {
                            callback();
                        }
                    });
                }
            } else {
                callback(new Error('请输入用户名'));
            }
        };

        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else if (value.length < 5 || value.length > 16) {
                callback(new Error('密码长度为6-16位'));
            } else {
                var reg = new RegExp(/^(?![^a-zA-Z]+$)(?!\D+$)/);
                if (!reg.test(value)) {
                    callback(new Error('密码仅支持字母、数字的组合'));
                } else {
                    callback();
                }
            }
        };
        var merchantServers = (rule, value, callback) => {
            console.log('服务', value);
            console.log(this.dynamicTags);
            var reg = /^[\u4e00-\u9fa5]+$/;
            if (this.dynamicTags.length == 0) {
                callback(new Error('请输入门店服务'));
            } else if (value.length > 5 || this.dynamicTags.length > 6) {
                callback(new Error('门店服务每个标签最大输入长度为5个字符且最多为6个标签'));
                this.dynamicTags.splice(this.dynamicTags.indexOf(value), 1);
            } else if (!reg.test(value)) {
                callback(new Error('请输入汉字'));
                this.dynamicTags.splice(this.dynamicTags.indexOf(value), 1);
            } else {
                function fn(Arr, num) {
                    let w = 0,
                        n;
                    for (let i = 0; i < Arr.length; i++) {
                        if (Arr.indexOf(num, i) != Arr.indexOf(num, i - 1)) {
                            w++;
                        }
                    }
                    return w;
                }
                console.log(fn(this.dynamicTags, value));
                var count = fn(this.dynamicTags, value);
                if (count >= 2) {
                    callback(new Error('请不要输入重复值'));
                    this.dynamicTags.splice(this.dynamicTags.indexOf(value), 1);
                } else {
                    callback();
                }
            }
        };
        return {
            // 新增表单数据
            imageUrl: '',
            quaImageUrl: '',
            addDialogVisible: false,
            dynamicTags: [],
            options: [
                {
                    value: '服务',
                    label: '服务'
                },
                {
                    value: '吃住',
                    label: '吃住'
                },
                {
                    value: '其他',
                    label: '其他'
                }
            ],
            addForm: {
                merchantType: '', //商家类型
                merchantName: '', //商家名称
                startWorkTime: '', //工作开始时间
                endWorkTime: '', //工作结束时间
                merchantAddress: '', //商家详细地址
                province: '', //省
                city: '', //市
                area: '', //区
                merchantFeatures: '', //商家卖点
                merchantTelephone: '', //联系电话
                merchantIntroduction: '', //商家简介
                merchantImg: '', //商家图片
                merchantServer: '', //门店服务
                merchantQuantityImg: '', //商家资质图片
                merchantLoginName: '', //商家登录账号
                merchantPassword: '' //商家密码
            },
            uploadUrl: 'upload/fileupload', //图片上传地址
            // 验证规则
            rules: {
                merchantType: [{ required: true, message: '请选择商家类型', trigger: 'change' }],
                merchantName: [
                    { validator: checkMerchantName, trigger: 'blur' },
                    { min: 1, max: 12, message: '门店名称长度为 1 到 12个字符', trigger: 'blur' }
                ],
                startWorkTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
                endWorkTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
                merchantAddress: [
                    { validator: checkMerchantAddress, trigger: 'blur' },
                    { min: 1, max: 30, message: '详细地址长度为 1 到 30 个字符', trigger: 'blur' }
                ],
                province: [{ required: true, message: '请选择省', trigger: 'change' }],
                city: [{ required: true, message: '请选择市', trigger: 'change' }],
                area: [{ required: true, message: '请选择区', trigger: 'change' }],
                merchantFeatures: [
                    { required: true, message: '请输入商家卖点', trigger: 'blur' },
                    { min: 2, max: 10, message: '商家卖点长度在 2 到 10个字符', trigger: 'blur' }
                ],
                merchantTelephone: [
                    {
                        required: true,
                        message: '请输入联系电话',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^(((\d{3,4}-)?[0-9]{7,8})|(1(3|4|5|6|7|8|9)\d{9}))$/,
                        message: '联系电话格式不正确！',
                        trigger: 'blur'
                    }
                ],
                merchantIntroduction: [{ required: true, message: '请输入门店简介', trigger: 'blur' }],
                merchantImg: [
                    {
                        required: true,
                        message: '请上传商家图片',
                        trigger: 'change'
                    }
                ],
                merchantQuantityImg: [
                    {
                        required: true,
                        message: '请上传资质图片',
                        trigger: 'change'
                    }
                ],
                merchantServer: [
                    { required: true, message: '请输入门店服务', trigger: 'blur' },
                    { validator: merchantServers, trigger: 'blur' }
                ],
                merchantLoginName: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { validator: checkLoginName, trigger: 'blur' }
                ],
                merchantPassword: [
                    { required: true, message: '请输入登录密码', trigger: 'blur' },
                    { validator: validatePass, trigger: 'blur' }
                ]
            },
            // 整个省市县数据
            city: city,
            // 被选中的市数据
            cityList: [],
            // 被选中的县数据
            areaList: [],
            selectProvince: {},
            selectCity: {},
            selectArea: {},
            pwdType1: 'password',
            isPwd1: false,
            inputVisible: false,
            inputValue: '',
            option: {
                img: '', // 裁剪图片的地址
                info: false, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: 'jpeg', // 裁剪生成图片的格式
                canScale: true, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 600, // 默认生成截图框宽度
                autoCropHeight: 700, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: false, // 是否开启截图框宽高固定比例
                // fixedNumber: [5.8, 6], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: true, // 截图框能否拖动
                canMove: false,
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            logoDialogVisible: false, //图片裁剪的弹框dialog
            logoFilename: '', //文件名
            quaDialogVisible: false, //图片裁剪的弹框dialog
            quaFilename: '', //文件名
            merchantLat: '',
            merchantLng: ''
        };
    },
    mounted() {
        // this.addQuillTitle();
        // 等页面dom元素加载完成后设置富文本编辑框的placeholder
        // document.getElementById('editor').children[1].children[0].setAttribute('data-placeholder', '请输入门店简介');
    },
    methods: {
        openDialog() {
            this.addDialogVisible = true;
            this.$nextTick(() => {
                document.getElementById('editor').children[1].children[0].setAttribute('data-placeholder', '请输入门店简介');
                this.addQuillTitle();
            });
        },
        handleAvatarSuccess() {},
        beforeAvatarUpload(file) {
            // let that = this;
            // console.log(file);
            // if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
            //     that.$message.error('请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片');
            //     return false;
            // }
            // const isLt2M = file.size / 1024 / 1024 < 2;
            // if (!isLt2M) {
            //     that.$message.error('图片大小必须小于2M');
            //     return false;
            // }
            // if (file.type && isLt2M) {
            //     let fd = new FormData(); //通过form数据格式来传
            //     let config = {
            //         headers: {
            //             'Content-Type': 'multipart/form-data'
            //         }
            //     };
            //     fd.append('file', file); //传文件
            //     that.$axios.post(that.uploadUrl, fd, config).then(function(res) {
            //         console.log(res.data);
            //         if (res.data.code == 0) {
            //             that.addForm.merchantImg = res.data.data.id;
            //             that.imageUrl = res.data.data.url;
            //         } else {
            //             that.$message.error(res.data);
            //         }
            //     });
            // }
        },
        quaHandleAvatarSuccess() {},
        BeforeAvatarUpload(file) {
            let that = this;
            console.log(file);
            if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                that.$message.error('请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片');
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                that.$message.error('图片大小必须小于2M');
                return false;
            }
            if (file.type && isLt2M) {
                let fd = new FormData(); //通过form数据格式来传
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                fd.append('file', file); //传文件
                that.$axios.post(that.uploadUrl, fd, config).then(function(res) {
                    console.log(res.data);
                    if (res.data.code == 0) {
                        that.addForm.merchantQuantityImg = res.data.data.id;
                        that.quaImageUrl = res.data.data.url;
                    } else {
                        that.$message.error(res.data);
                    }
                });
            }
        },
        uploadHandleChange(file) {
            // alert(5)
            this.logoFilename = file.name;
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isIMG = ['.jpeg', '.jpg', '.png', '.bmp', '.gif', '.JPEG', '.JPG', '.GIF', '.PNG', '.BMP'].some(r =>
                file.name.endsWith(r)
            );
            if (!isIMG) {
                this.$message.error('上传图片只能是 jpg、jpeg、gif、 png、bmp 格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
                return false;
            }
            this.$nextTick(() => {
                this.option.img = URL.createObjectURL(file.raw);
                this.logoDialogVisible = true;
            });
        },
        changeScale(val) {
            this.$refs.cropper.changeScale(val);
        },
        // 旋转图片
        rotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        rotateRight() {
            this.$refs.cropper.rotateRight();
        },
        //确定裁剪
        finish() {
            this.$refs.cropper.getCropData(res => {
                let file = this.dataURLtoFile(res, this.logoFilename);
                this.handleHttpRequest(file);
                this.logoDialogVisible = false;
            });
        },
        // base64转file
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        //上传事件
        async handleHttpRequest(file) {
            let that = this;
            console.log(file);
            let formData = new FormData();
            formData.append('file', file);
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            const res = await this.$axios.post(that.uploadUrl, formData, config);
            console.log(res);
            if (res.data.code == 0) {
                that.addForm.merchantImg = res.data.data.id;
                that.imageUrl = res.data.data.url;
            } else {
                this.$message.error(res.data);
            }
        },
        //点击关闭按钮时关闭裁剪弹出框
        handleClose() {
            this.logoDialogVisible = false;
        },
        submitForm() {
            let that = this;
            console.log(that.addForm);
            console.log(that.$refs.addForm.validate);
            that.$refs.addForm.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.$axios
                        .post('merchant/save', {
                            merchantType: that.addForm.merchantType, //商家类型
                            merchantName: that.addForm.merchantName, //商家类型
                            startWorkTime: that.addForm.startWorkTime, //商家类型
                            endWorkTime: that.addForm.endWorkTime, //商家类型
                            merchantAddress: that.addForm.merchantAddress, //商家类型
                            province: that.addForm.province, //商家类型
                            city: that.addForm.city, //商家类型
                            area: that.addForm.area, //商家类型
                            merchantFeatures: that.addForm.merchantFeatures, //商家类型
                            merchantStatus: that.addForm.merchantStatus, //商家类型
                            merchantTelephone: that.addForm.merchantTelephone, //商家类型
                            merchantIntroduction: that.addForm.merchantIntroduction, //商家类型
                            merchantImg: that.addForm.merchantImg, //商家类型
                            merchantServer: that.dynamicTags.length == 0 ? '' : that.dynamicTags.join('、'), //商家类型
                            merchantQuantityImg: that.addForm.merchantQuantityImg, //商家类型
                            merchantLoginName: that.addForm.merchantLoginName, //商家类型
                            merchantPassword: that.addForm.merchantPassword, //商家类型
                            merchantLng: that.merchantLng,
                            merchantLat: that.merchantLat
                        })
                        .then(res => {
                            console.log(res);
                            if (res.data.code == 0) {
                                that.$message.success('新增成功');
                                that.addDialogVisible = false;
                                that.$parent.getSysInfoList();
                                that.resetForm();
                                that.isPwd1 = false;
                                that.pwdType1 = 'password';
                                that.$axios
                                    .post('merchant/refreshQRImg', {
                                        merchantId: res.data.data.id
                                    })
                                    .then(res => {
                                        if (res.data.code == 0) {
                                            console.log('成功');
                                        }
                                    });
                                      that.$axios
                                    .post('merchant/setLngAndLat', {
                                        merchantId: res.data.data.id
                                    })
                                    .then(res => {
                                        if (res.data.code == 0) {
                                            console.log('成功');
                                        }
                                    });
                            } else {
                                that.$message.error(res.data.data);
                            }
                            console.log(res);
                        });
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm() {
            console.log(this.$refs);
            this.$refs.addForm.resetFields();
            this.addForm.merchantQuantityImg = '';
            this.addForm.merchantImg = '';
            this.imageUrl = '';
            this.quaImageUrl = '';
            this.dynamicTags = [];
            this.$emit('dialog', false);
        },
        resetFormData() {
            this.$refs.addForm.resetFields();
            this.addForm.merchantQuantityImg = '';
            this.addForm.merchantImg = '';
            this.addForm.imageUrl = '';
        },
        addQuillTitle() {
            // console.log(document.getElementsByClassName('ql-editor'));
            // document.getElementsByClassName('ql-editor')[0].placeholder = '';
            for (let item of titleConfig) {
                let tip = document.querySelector('.quill-editor ' + item.Choice);
                if (!tip) continue;
                tip.setAttribute('title', item.title);
            }
        },
        onEditorblur() {},
        // 富文本编辑器的change事件
        onEditorChange({ editor, html, text }) {},
        onEditorKeyDown(event) {},
        selectProvinceFun(event) {
            let that = this;
            if (event) {
                this.city.forEach(function(item) {
                    // console.log(item);
                    if (item.name == event) {
                        that.cityList = item.children;
                    }
                    // console.log(that.cityList);
                });
            } else {
                this.cityList = [];
            }
            this.areaList = [];
        },
        selectCityFun(event) {
            let that = this;
            // console.log(event);
            if (event) {
                this.cityList.forEach(function(item) {
                    // console.log(item);
                    if (item.name == event) {
                        that.areaList = item.children;
                    }
                    // console.log(that.areaList);
                });
            } else {
                this.areaList = [];
            }
        },
        selectAreaFun(event) {
            console.log(event);
        },
        handleToPwd1() {
            this.isPwd1 = !this.isPwd1;
            if (this.isPwd1) {
                this.pwdType1 = 'text';
            } else {
                this.pwdType1 = 'password';
            }
        },
        serveChange(e) {
            console.log(e);
        },
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },

        showInput() {
            let that = this;
            that.inputVisible = true;
            this.addForm.merchantServer = '';
            that.$nextTick(_ => {
                that.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.addForm.merchantServer;
            console.log(inputValue);
            if (inputValue.length > 2) {
                console.log(6666);
            }
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            // this.addForm.merchantServer = '';
        },
        handleToClose() {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.$refs.addForm.resetFields();
                    that.merchantQuantityImg = '';
                    that.merchantImg = '';
                    that.quaImageUrl = '';
                    that.imageUrl = '';
                    that.addDialogVisible = false;
                    that.isPwd1 = false;
                    that.pwdType1 = 'password';
                })
                .catch(() => {});
            // 重置表单
        },
        //资质裁剪
        changeScale(val) {
            this.$refs.cropper.changeScale(val);
        },
        // 旋转图片
        rotateLeft() {
            this.$refs.cropper.rotateLeft();
        },
        rotateRight() {
            this.$refs.cropper.rotateRight();
        },
        // base64转file
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        //上传事件
        // async quahandleHttpRequest(file) {
        //     let that = this;
        //     console.log(file);
        //     let formData = new FormData();
        //     formData.append('file', file);
        //     let config = {
        //         headers: {
        //             'Content-Type': 'multipart/form-data'
        //         }
        //     };
        //     const res = await this.$axios.post(that.uploadUrl, formData, config);
        //     console.log(res);
        //     if (res.data.code == 0) {
        //         that.addForm.merchantQuantityImg = res.data.data.id;
        //         that.quaImageUrl = res.data.data.url;
        //     } else {
        //         this.$message.error(res.data);
        //     }
        // },
        //点击关闭按钮时关闭裁剪弹出框
        handleCloses() {
            this.quaDialogVisible = false;
        }
        //
    }
};
</script>

<style lang="less" scoped>
.dialog-footer {
    text-align: right;
}
.el-select {
    width: 100%;
}
/deep/.el-input-number .el-input__inner {
    text-align: left;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border: 1px dashed #d9d9d9;
}
.avatar {
    width: 148px;
    height: 148px;
    display: block;
}
.pwd {
    color: #409eff;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
    display: inline-block;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 15px;
}
.cropper-content .cropper {
    width: auto;
    height: 300px;
}
.avatar-uploaders /deep/.el-upload{
    text-align: left!important;
}
</style>
